import React from "react";
import { ShieldCheck } from "lucide-react";
import { Section, Reveal } from "./shared";

export default function Guarantee() {
  return (
    <Section id="guarantee" bg="bg-brand-cream">
      <div className="grid lg:grid-cols-[0.8fr_1.2fr] gap-10 lg:gap-14 items-center">
        {/* Seal */}
        <Reveal>
          <div className="relative mx-auto w-56 h-56 sm:w-64 sm:h-64">
            <div className="absolute inset-0 rounded-full border-2 border-brand-black bg-brand-yellow flex flex-col items-center justify-center text-center" style={{ boxShadow: "8px 10px 0 #E90019" }}>
              <ShieldCheck size={44} className="text-brand-black" />
              <p className="font-display text-4xl mt-2">30</p>
              <p className="font-bold text-sm uppercase tracking-widest">Day Guarantee</p>
            </div>
            <span className="absolute -top-3 -right-3 h-14 w-14 rounded-full bg-brand-red border-2 border-brand-black flex items-center justify-center text-white font-display text-xs rotate-12">100%</span>
          </div>
        </Reveal>

        {/* Copy */}
        <Reveal delay={0.1}>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl leading-tight">
            Join With Confidence. You Have 30 Days to Decide.
          </h2>
          <div className="mt-5 space-y-3 text-sm sm:text-base text-brand-ink/75 leading-relaxed max-w-2xl">
            <p>Experience the training, understand the strategy, and decide whether the teaching style and program direction are right for you.</p>
            <p>Eligible approved refund requests made within the 30-day period will be processed according to the published refund terms.</p>
            <p>After a refund, course, community, live-session, template, and resource access ends. Payment-processing charges may be excluded where non-refundable.</p>
          </div>
          <div className="mt-6 rounded-[24px] border-2 border-brand-black bg-brand-black text-brand-cream p-6" style={{ boxShadow: "8px 10px 0 #4CAF48" }}>
            <p className="font-serif-e text-lg sm:text-xl leading-snug">
              I do not want you to stay because you cannot leave. <span className="text-brand-yellow font-bold">I want you to stay because you see value.</span>
            </p>
          </div>
        </Reveal>
      </div>
    </Section>
  );
}
